import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeStaffView.';

  public static readonly branch = `${Id.prefix}branch`;
  public static readonly singleBranchAccess = `${Id.prefix}singleBranchAccess`;
  public static readonly allBranchAccess = `${Id.prefix}allBranchAccess`;
  public static readonly branchAccess = `${Id.prefix}branchAccess`;
  public static readonly pleaseSelectBranchAccessLevel = `${Id.prefix}pleaseSelectBranchAccessLevel`;
  public static readonly pleaseSelectBranch = `${Id.prefix}pleaseSelectBranch`;
  public static readonly staff = `${Id.prefix}staff`;
  public static readonly unassigned = `${Id.prefix}unassigned`;
}

export class LangFranchiseeStaffView {
  private constructor() {}

  public static branch(): string {
    return interpolate(Id.branch);
  }
  public static singleBranchAccess(): string {
    return interpolate(Id.singleBranchAccess);
  }
  public static allBranchAccess(): string {
    return interpolate(Id.allBranchAccess);
  }
  public static branchAccess(): string {
    return interpolate(Id.branchAccess);
  }
  public static pleaseSelectBranchAccessLevel(): string {
    return interpolate(Id.pleaseSelectBranchAccessLevel);
  }
  public static pleaseSelectBranch(): string {
    return interpolate(Id.pleaseSelectBranch);
  }
  public static staff(): string {
    return interpolate(Id.staff);
  }
  public static unassigned(): string {
    return interpolate(Id.unassigned);
  }
}

export class FranchiseeStaffViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.branch, "{{glossary 'branch'}}", 'Label for branch');
    register.add(Id.singleBranchAccess, "Single {{glossary 'branch'}} access", 'Option for single branch access');
    register.add(Id.allBranchAccess, "All {{glossary 'branch:plural'}} access", 'Option for all branches access');
    register.add(Id.branchAccess, "{{glossary 'branch'}} Access", 'Label for branch access');
    register.add(
      Id.pleaseSelectBranchAccessLevel,
      "please select a {{glossary 'branch'}} access level",
      'Error for missing branch access level'
    );
    register.add(Id.pleaseSelectBranch, "please select a {{glossary 'branch'}}", 'Error for missing branch selection');
    register.add(Id.staff, 'Staff', 'Caption for staff view');
    register.add(Id.unassigned, 'Unassigned', 'Branch column label when a login has no valid branch assignment');
  }
}
